module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: [_vm.showIcon ? '' : 'fw-75', _vm.disabled ? 'disabled' : '', 'btn btn-info sq'],
    attrs: {
      "id": _vm.id + 'button'
    },
    on: {
      "click": _vm.promptFile
    }
  }, [_vm._v("\n  Upload "), (_vm.showIcon) ? _c('i', {
    staticClass: "fa fa-upload"
  }) : _vm._e(), _vm._v(" "), (_vm.showFile) ? _c('input', {
    staticClass: "hidden",
    attrs: {
      "type": "file",
      "id": _vm.id + 'input'
    },
    on: {
      "change": _vm.fileUploaded
    }
  }) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-aa4c5c12"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/helpers/ParseToJson.vue
// module id = 2265
// module chunks = 1